import React from 'react';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';

import './index.scss';

const LoaderComponent = () => {
  return (
    <div className="loader-wrapper container">
      <div className="round-loader">
        <MainLoader />
        <p className="loader-heading">
          <span className="color-red">Loading…</span>
          <br />
          Please Wait.
        </p>
      </div>
    </div>
  );
};

export default LoaderComponent;
